var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('nav',{attrs:{"id":"nav"}},[_c('Header')],1),_c('v-main',[_c('Error',{attrs:{"error":_vm.error},on:{"onClose":_vm.clear}}),_c('router-view')],1),_c('confirm',{ref:"confirm"}),_c('vue-snotify')],1)}
var staticRenderFns = []

export { render, staticRenderFns }